"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WindowType = void 0;
var WindowType;
(function (WindowType) {
    WindowType["Desktop"] = "desktop";
    WindowType["Offscreen"] = "offscreen";
})(WindowType = exports.WindowType || (exports.WindowType = {}));
//# sourceMappingURL=window_type.js.map